import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { VoiceRecognitionService } from 'app/masters/service/voice-recognition.service';

@Component({
  selector: 'app-aiprescription',
  templateUrl: './aiprescription.component.html',
  styleUrls: ['./aiprescription.component.scss']
})
export class AIPrescriptionComponent implements OnInit {
  private audioContext: AudioContext;
  private analyser: AnalyserNode;
  private dataArray: Uint8Array;
  private animationId: number;
  isListening = false;
  medicinedata = {
    medicine: '',
    qty: '',
    dosage: '',
    duration: '',
    unitqty: '',
    site:'',
    remark:''
  };
  newMedicine = [];
  prescription: string = '';
  speakingLang: string[] = ['en-US', 'en-UK', 'en-IN'];
  Examinationdisable:boolean =true;
  text = 'Hello! Welcome to AI-based prescriptions.';

  constructor(private voiceService: VoiceRecognitionService, private dialogRef: MatDialogRef<AIPrescriptionComponent>, @Optional() @Inject(MAT_DIALOG_DATA) private data: any) { 
    dialogRef.disableClose = true;
    this.voiceService.speakinglang='en-IN';
   // this.voiceService.inita();
    this.Examinationdisable=true;
    this.voiceService.recognition?.addEventListener('result', (e: any) => {
      let finalTranscript = '';
    
      for (let i = e.resultIndex; i < e.results.length; ++i) {
        const result = e.results[i];
        if (result.isFinal) {
          finalTranscript += result[0].transcript + ' ';
        }
      }
    
      const transcript = finalTranscript.trim().toLowerCase();
      console.log('Final Transcript:', transcript); // <-- This is your final value
    
      if (!transcript) return;
    
      if (transcript === 'next') {
        this.goToNextField();
        return;
      } else if (
        transcript === 'add' ||
        transcript === 'add medicine' ||
        transcript === 'other medicine' ||
        transcript === 'add medicines'
      ) {
        this.addMedicine();
        return;
      }
    
      if (this.prescription) {
        this.medicinedata[this.prescription] = this.medicinedata[this.prescription]
          ? this.medicinedata[this.prescription] + ' ' + transcript
          : transcript;
      }
    });
    
  }
 
  ngOnInit(): void {
   
  }
  fousVoice(field: string){
    this.prescription = field;
   // this.voiceService.start(field);
  }
  activateVoice(field: string) {
    this.Examinationdisable=false;
    this.prescription = field;
    this.voiceService.start(field); 
    this.initAudioVisualizer();
    const el = document.querySelector<HTMLInputElement>('input[name="medicine"]');
    el?.focus();
  }
 
  stopVoice() {
    this.Examinationdisable=true;
    this.voiceService.recognition.stop();
  }
 
  goToNextField() {
  
    if (this.prescription == "medicine") {
      this.prescription = "qty"; 
      const el = document.querySelector<HTMLInputElement>('input[name="qty"]');
      el?.focus();// Or loop back / go to the next logical field
    }
    else if (this.prescription == "qty") {
      this.prescription = "dosage"; 
      const el = document.querySelector<HTMLInputElement>('input[name="dosage"]');
      el?.focus();
    } else if (this.prescription == "dosage") {
      this.prescription = "duration"; 
      const el = document.querySelector<HTMLInputElement>('input[name="duration"]');
      el?.focus();
    }else if (this.prescription == "duration") {
      this.prescription = "unitqty"; 
      const el = document.querySelector<HTMLInputElement>('input[name="unitqty"]');
      el?.focus();
    }else if (this.prescription == "unitqty") {
      this.prescription = "site"; 
      const el = document.querySelector<HTMLInputElement>('input[name="site"]');
      el?.focus();
    }else if (this.prescription == "site") {
      this.prescription = "remark"; 
      const el = document.querySelector<HTMLInputElement>('input[name="remark"]');
      el?.focus();
    }
    else if (this.prescription == "remark") {
      this.prescription = ''; 
   
    }
  }
  addMedicine() {
    if(this.medicinedata.medicine){
      this.newMedicine.push(this.medicinedata );
      this.prescription = 'medicine'; 
      const el = document.querySelector<HTMLInputElement>('input[name="medicine"]');
      el?.focus();
     this.medicinedata = {
      medicine: '',
      qty: '',
      dosage: '',
      duration: '',
      unitqty: '',
      site:'',
      remark:''
    };
    }
  }
  removeMedicine(index: number) {
    this.newMedicine.splice(index, 1);
  }
 
  closedialog(){
    this.stopVoice();
    this.dialogRef.close();
  }
  changeLang(){
    this.stopVoice();
  }
  printPrescription() {
    window.print();
  }
  private async initAudioVisualizer(): Promise<void> {
    try {
      this.audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
      this.analyser = this.audioContext.createAnalyser();
      this.analyser.fftSize = 256;
      this.dataArray = new Uint8Array(this.analyser.frequencyBinCount);

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const source = this.audioContext.createMediaStreamSource(stream);
      source.connect(this.analyser);

      this.visualize();
    } catch (error) {
      console.error('Error accessing microphone:', error);
    }
  }

  private visualize(): void {
    this.analyser.getByteFrequencyData(this.dataArray);

    const canvas = document.getElementById('audioCanvas') as HTMLCanvasElement;
    const canvasCtx = canvas.getContext('2d');
    const WIDTH = canvas.width;
    const HEIGHT = canvas.height;

    // const draw = () => {
    //   canvasCtx.clearRect(0, 0, WIDTH, HEIGHT);
    //   const barWidth = (WIDTH / this.dataArray.length) * 2.5;
    //   let x = 0;

    //   for (let i = 0; i < this.dataArray.length; i++) {
    //     const barHeight = this.dataArray[i];
    //     canvasCtx.fillStyle = `rgb(${barHeight + 50}, 157, 252)`;
    //     canvasCtx.fillRect(x, HEIGHT - barHeight / 2, barWidth, barHeight / 2);
    //     x += barWidth + 1;
    //   }

    //   this.analyser.getByteFrequencyData(this.dataArray);
    //   this.animationId = requestAnimationFrame(draw);
    // };

    // draw();
    const draw = () => {
      canvasCtx.clearRect(0, 0, WIDTH, HEIGHT);
      const barWidth = (WIDTH / this.dataArray.length) * 1.5; // narrower bars
      let x = 0;
    
      for (let i = 0; i < this.dataArray.length; i++) {
        const barHeight = this.dataArray[i];
        const hue = (i / this.dataArray.length) * 360;
        canvasCtx.fillStyle = `hsl(${hue}, 100%, 50%)`;
        canvasCtx.shadowBlur = 10;
        canvasCtx.shadowColor = `hsl(${hue}, 100%, 50%)`;
        const y = HEIGHT - barHeight / 2;
        const height = barHeight / 2;
        const radius = 4;
        canvasCtx.beginPath();
        canvasCtx.moveTo(x, y + radius);
        canvasCtx.arcTo(x, y, x + barWidth, y, radius);
        canvasCtx.arcTo(x + barWidth, y, x + barWidth, y + height, radius);
        canvasCtx.arcTo(x + barWidth, y + height, x, y + height, radius);
        canvasCtx.arcTo(x, y + height, x, y, radius);
        canvasCtx.closePath();
        canvasCtx.fill();
    
        x += barWidth + 2; 
      }
      this.analyser.getByteFrequencyData(this.dataArray);
      this.animationId = requestAnimationFrame(draw);
    };
    
    draw();
  
    
    
  }
  ngOnDestroy(): void {
    if (this.audioContext) {
      this.audioContext.close();
    }
    cancelAnimationFrame(this.animationId);
    this.voiceService.recognition.stop();
  }
  closeCanvasModal(){
    this.stopVoice();
    this.Examinationdisable=true
  }
 
}
